import { action } from 'satcheljs';
import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';

export default action(
    'ON_FOLDER_CHANGE_DIGEST_RESPONSE',
    (pivot: InboxClassificationFilter, unseenCount: number, recentSenders: string[]) => ({
        pivot,
        unseenCount,
        recentSenders,
    })
);
